export const issues: Record<string, string> = {
  'nav.issues': 'Issues',
  'nav.myIssues': 'Issue của tôi',
  'nav.issuesAdmin': 'Quản trị',
  'issues.title': 'Issues',
  'issues.searchProjects': 'Tìm project…',
  'issues.open': 'đang mở',
  'issues.jiraMaster': 'Vẫn theo dõi trên Jira',
  'issues.import.button': 'Import',
  'issues.import.title': 'Import từ Jira',
  'issues.import.hint': 'Import file JSON xuất từ Jira vào space này',
  'issues.import.running': 'Đang import…',
  'issues.import.confirm': 'Import {n} issue từ "{file}" vào {key}? Issue đã có sẽ được cập nhật, không bị nhân đôi.',
  'issues.import.notJson': 'File không phải JSON hợp lệ.',
  'issues.import.notJira': 'File không phải bản xuất từ Jira (thiếu danh sách "issues").',
  'issues.import.empty': 'File không có issue nào.',
  'issues.import.wrongProject': 'File là bản xuất của {file}, không phải {key}.',
  'issues.import.done': 'Đã import {n} issue: {created} mới, {updated} cập nhật.',
  'issues.import.extras': '{comments} comment, {attachments} file đính kèm, {images} ảnh trong mô tả.',
  'issues.import.unmapped': 'Không khớp được với nhân viên (để trống người nhận):',
  'issues.import.unknownStatuses': 'Status Jira chưa biết (xếp theo nhóm):',
  'issues.noProjects': 'Chưa có project — import Jira chưa chạy.',
  'issues.noProjectsMember': 'Bạn chưa thuộc project nào — nhờ admin hoặc CTO thêm bạn vào.',
  'issues.tab.board': 'Board',
  'issues.tab.list': 'Danh sách',
  'issues.tab.backlog': 'Backlog',
  'issues.tab.summary': 'Tổng quan',
  'issues.tab.timeline': 'Timeline',
  'issues.tab.calendar': 'Lịch',
  'issues.status.BACKLOG': 'Backlog',
  'issues.status.TODO': 'To Do',
  'issues.status.IN_PROGRESS': 'In Progress',
  'issues.status.DEV_DONE': 'Dev Done',
  'issues.status.REOPEN': 'Reopen',
  'issues.status.NOT_BUG': 'Not Bug',
  'issues.status.DONE': 'Done',
  'issues.priority.HIGHEST': 'Rất cao',
  'issues.priority.HIGH': 'Cao',
  'issues.priority.MEDIUM': 'Trung bình',
  'issues.priority.LOW': 'Thấp',
  'issues.type.BUG': 'Bug',
  'issues.type.TASK': 'Task',
  'issues.col.key': 'Mã',
  'issues.col.title': 'Tiêu đề',
  'issues.col.type': 'Loại',
  'issues.col.status': 'Trạng thái',
  'issues.col.priority': 'Ưu tiên',
  'issues.col.assignee': 'Người xử lý',
  'issues.col.reporter': 'Người tạo',
  'issues.col.labels': 'Nhãn',
  'issues.col.updated': 'Cập nhật',
  'issues.col.project': 'Project',
  'issues.filter.search': 'Tìm tiêu đề, mô tả hoặc mã…',
  'issues.filter.status': 'Trạng thái',
  'issues.filter.type': 'Loại',
  'issues.filter.priority': 'Ưu tiên',
  'issues.filter.assignee': 'Người xử lý',
  'issues.filter.label': 'Nhãn',
  'issues.filter.unassigned': 'Chưa gán',
  'issues.list.total': '{n} issue',
  'issues.list.page': 'Trang {p}/{n}',
  'issues.list.prev': 'Trước',
  'issues.list.next': 'Sau',
  'issues.list.empty': 'Không có issue phù hợp.',
  'issues.bulk.selected': 'Đã chọn {n}',
  'issues.bulk.setStatus': 'Đổi trạng thái',
  'issues.bulk.assign': 'Gán cho',
  'issues.bulk.addLabel': 'Thêm nhãn',
  'issues.bulk.apply': 'Áp dụng',
  'issues.bulk.clear': 'Bỏ chọn',
  'issues.bulk.done': 'Đã cập nhật {n}, bỏ qua {s}',
  'issues.board.hiddenClosed': '{n} issue đóng quá {d} ngày nằm ở tab Danh sách.',
  'issues.board.empty': 'Trống.',
  'issues.board.readOnly': 'Bạn xem và báo bug được; QA, dev, admin và owner sản phẩm mới kéo thẻ.',
  'issues.board.sort': 'Sắp xếp',
  'issues.board.sortKey': 'Mã issue',
  'issues.board.sortUpdated': 'Cập nhật gần nhất',
  'issues.board.conflict': 'Có người vừa đổi issue này trước — đã tải lại.',
  'issues.board.error': 'Không lưu được thay đổi.',
  'issues.board.moveBlocked': 'Luồng không cho phép chuyển sang trạng thái đó.',
  'issues.backlog.hint': 'Kéo để sắp xếp. Issue do người không phải QA/dev tạo sẽ nằm đây chờ triage.',
  'issues.backlog.toTodo': 'To Do',
  'issues.backlog.empty': 'Backlog trống.',
  'issues.unassigned': 'Chưa gán',
  'issues.loadError': 'Không tải được issue.',
  'issues.list.error': 'Không tải được danh sách.',
  'issues.backlog.truncated': 'Đang hiện {n}/{total} đầu tiên; sắp xếp chỉ áp lên phần đã tải.',
  'issues.backlog.error': 'Không lưu được thứ tự mới.',
  'issues.create.landsInBacklog': 'Issue bạn báo sẽ nằm ở Backlog chờ QA triage.',
  'issues.a11y.drag': 'Kéo để sắp xếp',
  'issues.a11y.selectAll': 'Chọn tất cả trang này',
  'issues.a11y.select': 'Chọn {key}',
  'issues.a11y.sortBy': 'Sắp xếp theo {col}',
  'issues.a11y.pickedUp': 'Đã nhấc {key}',
  'issues.a11y.over': '{key} đang trên cột {status}',
  'issues.a11y.dropped': '{key} chuyển sang {status}',
  'issues.a11y.cancelled': 'Đã huỷ di chuyển',
  'issues.picker.last': 'Mở gần nhất',
  'issues.spaces': 'Spaces',
  'issues.picker.star': 'Yêu thích',
  'issues.picker.name': 'Tên',
  'issues.picker.type': 'Loại',
  'issues.picker.members': 'Thành viên',
  'issues.picker.typeJira': 'Đang theo dõi trên Jira',
  'issues.picker.typeSystem': 'Theo dõi tại đây',
  'issues.picker.delete': 'Xoá',
  'issues.picker.deleteAria': 'Xoá space {key}',
  'issues.picker.deleteTitle': 'Xoá space {name}?',
  'issues.picker.deleteMessage': 'Space {key} cùng {issues} issue và {docs} trang Docs sẽ bị xoá vĩnh viễn; {members} thành viên mất quyền truy cập. Không thể hoàn tác.',
  'issues.picker.deleteTypeKey': 'Gõ {key} để xác nhận',
  'nav.docs': 'Tài liệu',
  'nav.docs.trash': 'Thùng rác',
  'md.bold': 'Đậm',
  'md.italic': 'Nghiêng',
  'md.code': 'Code',
  'md.list': 'Danh sách',
  'md.numbered': 'Danh sách số',
  'md.link': 'Link',
  'md.image': 'Link ảnh',
  'md.imageUrl': 'URL ảnh (https)',
  'md.linkUrl': 'URL link (https)',
  'md.item': 'mục',
  'md.write': 'Soạn',
  'md.preview': 'Xem trước',
  'md.nothing': 'Chưa có gì để xem.',
  'md.copy': 'Sao chép mã',
  'md.copied': 'Đã chép',
  'md.wrap': 'Xuống dòng dài',
  'md.plainText': 'text',
  'md.placeholder': 'Markdown. Dán link YouTube cho video, link ảnh cho ảnh chụp, @mã để nhắc ai đó.',
  'md.hint': 'Không upload file: dán link YouTube (unlisted) cho video và link ảnh cho ảnh chụp màn hình.',
  'issues.create.title': 'Tạo issue',
  'issues.create.clone': 'Nhân bản',
  'issues.create.submit': 'Tạo',
  'issues.create.cancel': 'Huỷ',
  'issues.create.titleField': 'Tiêu đề',
  'issues.create.description': 'Mô tả',
  'issues.create.labels': 'Nhãn (cách nhau bằng dấu phẩy)',
  'issues.create.assignee': 'Người xử lý',
  'issues.create.type': 'Loại',
  'issues.create.priority': 'Ưu tiên',
  'issues.create.error': 'Không tạo được issue.',
  'issues.create.jiraMaster': 'Project này vẫn theo dõi trên Jira — tạo issue ở đó.',
  'issues.detail.notFound': 'Không tìm thấy issue.',
  'issues.detail.description': 'Mô tả',
  'issues.detail.noDescription': 'Chưa có mô tả.',
  'issues.detail.edit': 'Sửa',
  'issues.detail.save': 'Lưu',
  'issues.detail.cancel': 'Huỷ',
  'issues.detail.delete': 'Xoá',
  'issues.detail.deleteConfirm': 'Xoá issue này? Sẽ biến mất khỏi mọi danh sách; lịch sử vẫn giữ.',
  'issues.detail.watch': 'Theo dõi',
  'issues.detail.unwatch': 'Bỏ theo dõi',
  'issues.detail.copyLink': 'Sao chép liên kết',
  'issues.detail.linkCopied': 'Đã sao chép liên kết',
  'issues.copyLinkFor': 'Sao chép liên kết tới {key}',
  'issues.detail.watchers': 'Người theo dõi',
  'issues.detail.reporter': 'Người tạo',
  'issues.detail.created': 'Tạo lúc',
  'issues.detail.updated': 'Cập nhật',
  'issues.detail.resolved': 'Đóng lúc',
  'issues.detail.jira': 'Import từ Jira',
  'issues.detail.conflict': 'Có người vừa đổi issue này trước — đã tải lại.',
  'issues.detail.saveError': 'Không lưu được.',
  'issues.detail.openFull': 'Mở trang đầy đủ',
  'issues.detail.close': 'Đóng',
  'issues.comments.title': 'Bình luận',
  'issues.comments.add': 'Gửi',
  'issues.comments.placeholder': 'Viết bình luận… @mã để nhắc',
  'issues.comments.edit': 'Sửa',
  'issues.comments.delete': 'Xoá',
  'issues.comments.deleteConfirm': 'Xoá bình luận này?',
  'issues.comments.empty': 'Chưa có bình luận.',
  'issues.comments.edited': 'đã sửa',
  'issues.comments.reply': 'Trả lời',
  'issues.comments.replyingTo': 'Đang trả lời',
  'issues.comments.replyPlaceholder': 'Viết trả lời… @mã để nhắc đến',
  'issues.attachments.title': 'Link & đính kèm',
  'issues.docs.title': 'Tài liệu',
  'issues.attachments.add': 'Thêm link',
  'issues.attachments.url': 'https://…',
  'issues.attachments.name': 'Tên (tuỳ chọn)',
  'issues.attachments.jiraHint': 'Import từ Jira: cần đăng nhập Jira và sẽ mất khi tắt Jira.',
  'issues.attachments.remove': 'Gỡ',
  'issues.attachments.empty': 'Chưa có link.',
  'issues.attachments.error': 'Phải là link https.',
  'issues.links.title': 'Issue liên quan',
  'issues.links.add': 'Liên kết issue',
  'issues.links.key': 'Mã issue, vd NP27-12',
  'issues.links.DUPLICATES': 'trùng với',
  'issues.links.BLOCKS': 'chặn',
  'issues.links.RELATES': 'liên quan',
  'issues.links.empty': 'Chưa có issue liên quan.',
  'issues.history.title': 'Lịch sử',
  'issues.history.empty': 'Chưa có lịch sử.',
  'issues.history.created': 'đã tạo',
  'issues.history.comment': 'bình luận',
  'issues.history.attachment': 'đính kèm',
  'issues.history.link': 'liên kết issue',
  'issues.history.commentEdited': 'sửa bình luận',
  'issues.history.commentRemoved': 'xoá bình luận',
  'issues.history.attachmentRemoved': 'gỡ link',
  'issues.history.linkRemoved': 'bỏ liên kết issue',
  'issues.history.deleted': 'đã xoá',
  'issues.history.descriptionMd': 'sửa mô tả',
  'issues.admin.hint': 'Mỗi project một webhook. Lưu phía server, chỉ hiển thị dạng che.',
  'issues.admin.webhook': 'URL webhook',
  'issues.admin.save': 'Lưu',
  'issues.admin.clear': 'Gỡ',
  'issues.admin.saved': 'Đã lưu',
  'issues.admin.error': 'Phải là URL webhook Discord.',
  'issues.admin.none': 'chưa đặt',
  'issues.admin.tabMembers': 'Thành viên',
  'issues.admin.tabWebhooks': 'Webhook Discord',
  'issues.admin.tabTemplates': 'Mẫu tài liệu',
  'issues.admin.members.title': 'Thành viên',
  'issues.admin.members.projects': 'Project',
  'issues.admin.members.onlyEmpty': 'Chỉ project chưa có ai',
  'issues.admin.members.pick': 'Chọn project bên trái. Dev (App Permissions) và MO (gán app Monet) tự là thành viên; thêm tay QA, ASO, Design và ngoại lệ. Chỉ thành viên thấy project; admin và CTO thấy tất cả.',
  'issues.admin.members.none': 'Chưa có thành viên — chỉ admin và CTO thấy project này.',
  'issues.admin.members.search': 'Thêm người (tên hoặc mã)…',
  'issues.admin.members.remove': 'Gỡ',
  'issues.admin.members.save': 'Lưu',
  'issues.admin.members.saved': 'Đã lưu',
  'issues.admin.members.sourceDev': 'App Permissions',
  'issues.admin.members.sourceMonet': 'Gán app Monet',
  'issues.admin.members.sourceRole': 'Theo chức danh (CTO)',
  'issues.admin.project.new': '+ Space mới',
  'issues.admin.project.key': 'Mã space',
  'issues.admin.project.kind': 'Loại',
  'issues.admin.project.kindIssues': 'Space Issues (board + tài liệu)',
  'issues.admin.project.kindDocs': 'Space chỉ cho tài liệu',
  'issues.admin.project.audience': 'Ai được xem trong Docs',
  'issues.admin.project.audienceCompany': 'Cả công ty (như Company)',
  'issues.admin.project.audienceMembers': 'Chỉ thành viên',
  'issues.admin.project.keyHint': 'Chữ hoa, 2–16 ký tự — đây là tiền tố của mọi mã issue trong space (ví dụ NP34-1). Đổi về sau được, nhưng mọi issue sẽ đổi mã theo.',
  'issues.admin.project.name': 'Tên space',
  'issues.admin.project.pCode': 'Mã app (tuỳ chọn)',
  'issues.admin.project.pCodeHint': 'Gắn với app trong ERP để lấy sẵn dev và người phụ trách Monet. Design, tester và các trường hợp khác vẫn thêm tay ở danh sách bên cạnh.',
  'issues.admin.project.create': 'Tạo space',
  'issues.admin.project.rename': 'Đổi tên',
  'issues.admin.project.renameSave': 'Lưu',
  'issues.admin.project.rekey': 'Đổi mã issue',
  'issues.admin.project.rekeyHint': 'Chữ in hoa, 2–16 ký tự. Mọi issue được đổi sang mã mới (NP27-12 → PUZ-12), link trong Docs, mô tả và comment cũng được cập nhật.',
  'issues.admin.project.rekeyJira': 'Space này vẫn do Jira quản lý — hãy "Tiếp quản từ Jira" trước khi đổi mã issue.',
  'issues.admin.project.rekeyConfirm': 'Đổi mã issue {old} → {new}?\n\n• {issues} issue sẽ thành {new}-… (giữ nguyên số)\n• {docs} trang Docs chuyển sang {new}\n• Link trong Docs, mô tả, comment và thông báo được cập nhật\n\nBookmark hoặc link bên ngoài app trỏ tới {old} sẽ không còn dùng được.',
  'issues.admin.project.rekeyRunning': 'Đang đổi…',
  'issues.admin.project.rekeyDone': 'Đã đổi mã issue — cập nhật {issues} issue, {docs} trang Docs, {references} chỗ tham chiếu.',
  'issues.admin.project.takeOver': 'Tiếp quản từ Jira',
  'issues.admin.project.takeOverHint': 'Space này vẫn do Jira quản lý nên chưa tạo được issue mới. Tiếp quản để quản lý ngay trong ứng dụng này.',
  'issues.admin.project.takeOverConfirm': 'Tiếp quản space này từ Jira? Space sẽ do hệ thống quản lý và cho phép tạo issue mới; tiến trình đồng bộ Jira sẽ ngừng ghi vào space này. Không thể hoàn tác.',
  'issues.admin.project.takeOverDone': 'Đã tiếp quản — space này giờ tạo được issue mới.',
  'issues.admin.members.derivedHint': 'Suy từ gán app trong ERP; đổi ở đó.',
  'issues.admin.members.derivedHintRole': 'Thành viên mọi project theo chức danh CTO.',
  'issues.admin.members.exclude': 'Loại khỏi project',
  'issues.admin.members.excludeHint': 'Loại khỏi riêng project này; gán app trong ERP giữ nguyên.',
  'issues.admin.tabWorkflow': 'Luồng',
  'issues.workflow.pick': 'Chọn một Space bên trái để xem và sửa luồng của nó.',
  'issues.workflow.diagram': 'Sơ đồ',
  'issues.workflow.text': 'Văn bản',
  'issues.workflow.addTransition': 'Thêm chuyển tiếp',
  'issues.workflow.createTransition': 'Tạo chuyển tiếp',
  'issues.workflow.editTransition': 'Sửa chuyển tiếp',
  'issues.workflow.transitionHint': 'Chuyển tiếp nối các trạng thái — là những bước người dùng có thể chuyển trên board, đồng thời là vùng thả khi kéo thẻ.',
  'issues.workflow.namePlaceholder': 'Đặt tên cho chuyển tiếp, ví dụ "Bắt đầu làm"',
  'issues.workflow.addStatus': 'Thêm trạng thái',
  'issues.workflow.autoLayout': 'Tự sắp xếp',
  'issues.workflow.start': 'BẮT ĐẦU',
  'issues.workflow.any': 'Mọi trạng thái',
  'issues.workflow.name': 'Tên chuyển tiếp',
  'issues.workflow.from': 'Từ',
  'issues.workflow.to': 'Đến',
  'issues.workflow.save': 'Lưu',
  'issues.workflow.create': 'Thêm',
  'issues.workflow.delete': 'Xoá',
  'issues.workflow.deleteConfirm': 'Xoá chuyển tiếp này?',
  'issues.workflow.status': 'Trạng thái',
  'issues.workflow.statuses': 'Trạng thái',
  'issues.workflow.transitions': 'Chuyển tiếp',
  'issues.workflow.noTransitions': 'Chưa có chuyển tiếp nào — mọi thay đổi trạng thái đều được phép cho tới khi bạn thêm.',
  'issues.workflow.dragHint': 'Kéo từ chấm tròn ở cạnh phải một trạng thái sang trạng thái khác để tạo chuyển tiếp.',
  'issues.workflow.error': 'Không lưu được thay đổi luồng.',
  'issues.workflow.saveChanges': 'Lưu thay đổi',
  'issues.workflow.discard': 'Huỷ bỏ',
  'issues.workflow.unsaved': 'Có thay đổi chưa lưu',
  'issues.workflow.discardConfirm': 'Có thay đổi workflow chưa lưu. Huỷ bỏ chúng?',
  'issues.workflow.duplicate': 'Đã có chuyển tiếp cùng from → to.',
  'issues.workflow.selfLoop': 'Chuyển tiếp không thể trỏ về chính trạng thái đó.',
  'issues.workflow.category': 'Nhóm',
  'issues.workflow.category.todo': 'Chờ làm',
  'issues.workflow.category.in_progress': 'Đang làm',
  'issues.workflow.category.done': 'Xong (đóng)',
  'issues.workflow.color': 'Màu',
  'issues.workflow.moveUp': 'Lên',
  'issues.workflow.moveDown': 'Xuống',
  'issues.workflow.deleteStatusConfirm': 'Xoá trạng thái này? Không được còn issue nào đang dùng.',
  'issues.field.dueDate': 'Hạn xử lý',
  'issues.field.noDueDate': 'Chưa có hạn',
  'issues.summary.open': 'Đang mở',
  'issues.summary.created7d': 'Tạo mới · 7 ngày',
  'issues.summary.closed7d': 'Đã đóng · 7 ngày',
  'issues.summary.reopenRate': 'Tỷ lệ reopen · 90 ngày',
  'issues.summary.byStatus': 'Theo trạng thái',
  'issues.summary.byPriority': 'Đang mở theo độ ưu tiên',
  'issues.summary.byAssignee': 'Đang mở theo người xử lý',
  'issues.summary.weekly': 'Tạo mới vs đóng · 8 tuần gần nhất',
  'issues.summary.created': 'Tạo mới',
  'issues.summary.closed': 'Đã đóng',
  'issues.summary.unassigned': 'Chưa giao',
  'issues.summary.empty': 'Project chưa có issue nào.',
  'issues.timeline.hint': 'Issue đang mở có hạn xử lý: thanh từ ngày tạo tới hạn. Muốn đổi thì sửa hạn trên issue.',
  'issues.timeline.zoom': 'Mức xem',
  'issues.timeline.zoomDay': 'Ngày',
  'issues.timeline.zoomWeek': 'Tuần',
  'issues.timeline.zoomMonth': 'Tháng',
  'issues.timeline.groupAssignee': 'Gom theo người xử lý',
  'issues.timeline.truncated': '{n}/{total} issue trong cửa sổ này chưa hiện (giới hạn 200 dòng); thu hẹp cửa sổ hoặc dùng tab Danh sách.',
  'issues.timeline.empty': 'Chưa issue đang mở nào có hạn xử lý. Đặt hạn trên issue để thấy ở đây.',
  'issues.timeline.overdue': 'Quá hạn',
  'issues.timeline.noDueCount': 'Còn {n} issue đang mở chưa có hạn, hoặc có hạn ngoài khoảng này.',
  'issues.calendar.hint': 'Issue theo hạn xử lý. Bấm vào ngày để xem issue của ngày đó.',
  'issues.calendar.hintManage': 'Issue theo hạn xử lý. Bấm vào ngày để xem; kéo thẻ sang ngày khác để dời hạn.',
  'issues.calendar.truncated': '{n}/{total} issue trong khoảng này chưa hiện (giới hạn 200 dòng).',
  'issues.calendar.dayEmpty': 'Ngày này không có hạn nào.',
  'issues.calendar.today': 'Hôm nay',
  'issues.calendar.prev': 'Tháng trước',
  'issues.calendar.next': 'Tháng sau',
  'issues.calendar.empty': 'Tháng này không có hạn nào.',
  'issues.calendar.more': 'nữa',
  'issues.quick.add': 'Tạo nhanh cho ngày này',
  'issues.quick.hintManage': 'Rê chuột vào một ngày và bấm + để tạo nhanh task/bug có hạn là ngày đó (mốc: xong tính năng, build test, release…). Issue tạo ra nằm ở Backlog.',
  'issues.quick.placeholder': 'Cần làm gì?',
  'issues.quick.create': 'Tạo',
  'issues.quick.hint': 'Enter để tạo · Shift+Enter xuống dòng · Esc đóng',
  'issues.quick.error': 'Không tạo được issue.',
  'issues.quick.created': 'đã tạo, đang nằm ở Backlog.',
  'docs.title': 'Tài liệu',
  'docs.scope.all': 'Công ty',
  'docs.space.create': 'Tạo space',
  'docs.space.settings': 'Cài đặt space',
  'docs.space.saved': 'Đã lưu',
  'docs.space.members': 'Thành viên',
  'docs.space.removeMember': 'Bỏ khỏi space',
  'docs.space.byRole': 'theo chức danh',
  'docs.space.preset': 'Bộ quyền',
  'docs.space.preset.CUSTOM': 'Tuỳ chỉnh',
  'docs.space.preset.NONE': "Không có quyền",
  'docs.space.perm.VIEW': 'Xem',
  'docs.space.perm.COMMENT': 'Bình luận',
  'docs.space.perm.EDIT': 'Thêm/ sửa',
  'docs.space.perm.DELETE_OWN': 'Xoá của mình',
  'docs.space.perm.DELETE_ANY': 'Xoá của người khác',
  'docs.space.perm.RESTRICT': 'Hạn chế',
  'docs.space.perm.EXPORT': 'Export',
  'docs.space.perm.ADMIN': 'Quản trị',
  'docs.space.permHint.VIEW': 'Đọc các trang trong space (luôn bật — muốn bỏ quyền thì xoá dòng)',
  'docs.space.permHint.COMMENT': 'Thêm bình luận',
  'docs.space.permHint.EDIT': 'Tạo trang (cấp gốc, trang con, sao chép, chuyển vào) và sửa mọi trang',
  'docs.space.permHint.DELETE_OWN': 'Chuyển trang do mình tạo vào thùng rác',
  'docs.space.permHint.DELETE_ANY': 'Chuyển trang của người khác vào thùng rác, xoá bình luận của người khác',
  'docs.space.permHint.RESTRICT': 'Đặt trang riêng tư / công khai và quản lý chia sẻ trang',
  'docs.space.permHint.EXPORT': 'In / xuất trang',
  'docs.space.permHint.ADMIN': 'Toàn quyền, thêm cài đặt, phân quyền, xoá space, chuyển trang ra ngoài, xem trang riêng tư',
  'docs.space.you': 'Bạn (người tạo)',
  'docs.space.createMembersHint': 'Bạn có toàn quyền trong space. Thêm người khác và tick quyền riêng cho họ — quyền riêng thay cho quyền theo phòng ban / chức danh.',
  'docs.space.delete': 'Xoá space…',
  'docs.space.deleteWarn': 'Xoá vĩnh viễn space {key} cùng {pages} trang (kể cả trong thùng rác), bản nháp và template của nó. Không thể khôi phục.',
  'docs.space.deleteType': 'Gõ {key} để xác nhận',
  'docs.space.deleteConfirm': 'Xoá vĩnh viễn',
  'docs.space.roleRules': "Quyền theo nhóm",
  'docs.space.roleRulesHint': "\"Mọi người trong công ty\" là quyền của ai không phải thành viên — bỏ tick Xem thì space chỉ dành cho thành viên. Ai thuộc phòng ban / chức danh được thêm đều có các quyền được tick; khớp nhiều dòng thì quyền được cộng dồn.",
  'docs.space.roleRulesEmpty': 'Chưa có — chỉ các thành viên bên dưới vào được space.',
  'docs.space.everyone': "Mọi người trong công ty",
  'docs.space.everyoneOn': "Space mở cho cả công ty",
  'docs.space.everyoneOff': "Chỉ thành viên mới thấy space",
  'docs.company.settings': "Quyền Space Công ty",
  'docs.company.rulesHint': "\"Mọi người trong công ty\" luôn được Xem; tick thêm để cho cả công ty bình luận, tạo/sửa trang… Phòng ban / chức danh được thêm có thêm các quyền được tick (cộng dồn). Chỉ admin / CTO quản trị Space Công ty.",
  'docs.company.people': "Quyền riêng từng người",
  'docs.company.peopleHint': "Người có dòng riêng dùng đúng quyền ở dòng đó, thay cho quyền của cả công ty và phòng ban / chức danh — dùng để mở thêm hoặc siết bớt cho một người.",
  'docs.space.ruleKind.dept': 'Phòng ban',
  'docs.space.ruleKind.title': 'Chức danh',
  'docs.space.ruleCode': 'Phòng ban / chức danh',
  'docs.space.ruleAdd': '+ Thêm phòng ban / chức danh',
  'docs.space.ruleRemove': 'Bỏ dòng này',
  'docs.space.membersHint': 'Người được thêm tay dùng quyền riêng ở dòng của mình, thay cho quyền theo phòng ban / chức danh.',
  'docs.space.issuesMembersHint': 'Thành viên dùng chung với project Issues, mặc định quyền Editor. Chỉ Admin/CTO thêm được người (người đó vào cả Issues); muốn bớt người thì làm ở trang Admin của Issues.',
  'docs.space.role.VIEWER': 'Xem',
  'docs.space.role.EDITOR': 'Sửa',
  'docs.space.role.MANAGER': 'Quản lý',
  'docs.readOnlyRole': 'Bạn chỉ có quyền xem trong space này — không tạo hay sửa trang được.',
  'docs.space.addMember': 'Thêm thành viên — gõ tên…',
  'docs.space.keyHint': 'Mã ngắn, chữ A–Z và số, dùng trong đường link (/docs/WIKI). Admin đổi được về sau trong Issues → Quản trị.',
  'docs.scope.docsSpaces': 'Không gian tài liệu',
  'docs.scope.projectSpaces': 'Không gian dự án',
  'docs.scope.mine': 'Trang của tôi',
  'docs.search': 'Tìm trang…',
  'docs.searchEmpty': 'Không có trang nào khớp.',
  'docs.new': 'Trang mới',
  'docs.newChild': 'Trang con mới',
  'docs.empty': 'Chưa có trang nào.',
  'docs.pickPage': 'Chọn một trang trong cây, hoặc tạo trang mới.',
  'docs.notFound': 'Không tìm thấy trang.',
  'docs.loadError': 'Không tải được tài liệu.',
  'docs.edit': 'Sửa',
  'docs.save': 'Lưu',
  'docs.cancel': 'Huỷ',
  'docs.titlePlaceholder': 'Tiêu đề trang',
  'docs.width.label': 'Điều chỉnh chiều rộng',
  'docs.width.narrow': 'Hẹp',
  'docs.width.wide': 'Rộng',
  'docs.width.max': 'Tối đa',
  'docs.publish': 'Công khai',
  'docs.unpublish': 'Chuyển riêng tư',
  'docs.private': 'Riêng tư',
  'docs.share': 'Chia sẻ',
  'docs.restricted': 'Bị hạn chế',
  'docs.share.title': 'Chia sẻ trang',
  'docs.share.hint': 'Gửi đường dẫn trang kèm lời nhắn. Chia sẻ không cấp thêm quyền — ai chưa xem được sẽ thấy nút xin quyền.',
  'docs.share.message': 'Lời nhắn (không bắt buộc)',
  'docs.share.send': 'Gửi',
  'docs.share.sent': 'Đã gửi cho {n} người.',
  'docs.share.copyLink': 'Sao chép liên kết',
  'docs.share.copied': 'Đã sao chép liên kết.',
  'docs.share.error': 'Không thực hiện được.',
  'docs.restrict.btn': 'Hạn chế',
  'docs.restrict.title': 'Hạn chế trang',
  'docs.restrict.mode.none': 'Không hạn chế',
  'docs.restrict.modeHint.none': 'Ai có quyền trong Space đều xem và sửa được (theo quyền của Space).',
  'docs.restrict.mode.edit': 'Ai cũng xem được, chỉ một số người được sửa',
  'docs.restrict.modeHint.edit': 'Chỉ những người/nhóm bên dưới được sửa. Không áp cho trang con.',
  'docs.restrict.mode.view': 'Chỉ một số người được xem hoặc sửa',
  'docs.restrict.modeHint.view': 'Chỉ những người/nhóm bên dưới thấy trang này — và mọi trang con của nó.',
  'docs.restrict.inherited': 'Trang này còn bị hạn chế xem bởi trang phía trên (chỉnh ở đó):',
  'docs.restrict.onlyYou': 'Chỉ chủ trang và quản lý Space.',
  'docs.restrict.kind.user': 'Người',
  'docs.restrict.level': 'Quyền',
  'docs.restrict.level.view': 'Xem',
  'docs.restrict.level.edit': 'Xem & sửa',
  'docs.restrict.remove': 'Gỡ',
  'docs.restrict.addPerson': 'Thêm người…',
  'docs.restrict.addGroup': 'Thêm phòng ban / chức danh…',
  'docs.restrict.youStay': 'Bạn luôn được giữ trong danh sách với quyền sửa. Hạn chế chỉ thu hẹp quyền Space đã cho, không mở rộng.',
  'docs.request.restrictedTitle': 'Trang này bị hạn chế',
  'docs.request.restrictedHint': 'Bạn chưa có quyền xem trang này. Gửi yêu cầu tới chủ trang hoặc quản lý Space.',
  'docs.request.message': 'Lời nhắn (không bắt buộc)',
  'docs.request.view': 'Xin quyền xem',
  'docs.request.edit': 'Xin quyền sửa',
  'docs.request.sent': 'Đã gửi yêu cầu — bạn sẽ nhận thông báo khi được duyệt.',
  'docs.request.panelTitle': 'Yêu cầu truy cập đang chờ',
  'docs.request.wantsView': 'muốn xem',
  'docs.request.wantsEdit': 'muốn sửa',
  'docs.request.approve': 'Duyệt',
  'docs.request.deny': 'Từ chối',
  'docs.owner': 'Chủ trang',
  'docs.updated': 'Cập nhật',
  'docs.confluence': 'Nhập từ Confluence',
  'docs.confluenceHint': 'Ảnh trong trang vẫn trỏ về Confluence và sẽ hỏng khi tắt Confluence.',
  // Phiên bản / so sánh (Phase 5)
  'docs.versionLabel': 'v{n}',
  'docs.editedBy': 'sửa bởi',
  'docs.compare': 'So sánh',
  'docs.comparePick': 'Chọn phiên bản này để so sánh',
  'docs.compareHeading': 'So sánh {a} → {b}',
  'docs.compareHighlight': 'Tô thay đổi',
  'docs.revisions': 'Lịch sử',
  'docs.revisionsEmpty': 'Chưa có bản sửa nào.',
  'docs.restore': 'Khôi phục',
  'docs.restoreConfirm': 'Khôi phục bản này? Nội dung hiện tại được giữ thành một bản sửa.',
  'docs.saveError': 'Không lưu được trang.',
  'docs.readOnly': 'Chỉ đọc: trang bị hạn chế sửa hoặc quyền của bạn trong Space không cho sửa.',
  'docs.noParent': 'Cấp cao nhất',
  'docs.collapse': 'Thu gọn',
  'docs.expand': 'Mở rộng',
  'docs.pagesCount': '{n} trang',
  // Di chuyển / sao chép / sắp xếp cây (Phase 4)
  'docs.move': 'Di chuyển…',
  'docs.moveTo': 'Di chuyển vào',
  'docs.moveSpace': 'Space',
  'docs.moveSpaceNote': 'Chuyển sang space khác sẽ mang theo toàn bộ trang con. Trang nào trùng địa chỉ ở space đích sẽ được thêm số, và các link trỏ tới các trang này được cập nhật.',
  'docs.copy': 'Sao chép',
  'docs.copyConfirm': 'Tạo bản sao của trang này?',
  'docs.copyConfirmChildren': 'Sao chép trang này và tất cả trang con?',
  'docs.reorder': 'Kéo để sắp xếp',
  'docs.pageMenu': 'Thao tác trang',
  // Thùng rác (Phase 4b)
  'docs.trash': 'Chuyển vào thùng rác',
  'docs.trashConfirm': 'Chuyển trang này và các trang con vào thùng rác? Bạn có thể khôi phục trong 30 ngày.',
  'docs.trashScope': '🗑 Thùng rác',
  'docs.trashTitle': 'Thùng rác',
  'docs.trashEmpty': 'Thùng rác trống.',
  'docs.trashRetention': 'Mục sẽ bị xoá vĩnh viễn sau {n} ngày.',
  'docs.trashedAt': 'Đã xoá',
  'docs.deleteNow': 'Xoá ngay',
  'docs.deleteNowConfirm': 'Xoá vĩnh viễn trang này và toàn bộ lịch sử? Không thể hoàn tác.',
  'docs.restoredReRooted': 'Trang cha ban đầu vẫn đang ở thùng rác, nên trang được khôi phục ở cấp cao nhất.',
  'docs.editor.new': 'Trang mới',
  'docs.editor.edit': 'Sửa trang',
  'docs.current': 'Hiện tại',
  'docs.bodyEmpty': 'Trang này chưa có nội dung.',
  // Trình soạn thảo (Phase 2)
  'docs.rt.placeholder': 'Nhập nội dung… gõ “/” để chèn khối, “@” để nhắc tên ai đó.',
  'docs.rt.slashHint': 'Gõ “/” để chèn khối · “@” để nhắc tên',
  'docs.rt.showSource': 'Mã Markdown',
  'docs.rt.hideSource': 'Về trình soạn thảo',
  'docs.rt.sourceHint': 'Markdown chỉ đọc, sinh ra từ trang — sao chép cho agent hoặc để ghi chú.',
  'docs.rt.unsavedConfirm': 'Bạn có thay đổi chưa lưu. Rời đi mà không lưu?',
  'docs.rt.conflict': 'Trang đã thay đổi kể từ khi bạn mở. Tải lại để xem bản mới nhất rồi áp dụng lại chỉnh sửa của bạn.',
  'docs.rt.conflictConfirm': 'Người khác vừa lưu một phiên bản mới hơn của trang này trong lúc bạn chỉnh sửa. Ghi đè thay đổi của họ bằng của bạn?',
  'docs.rt.overwrite': 'Ghi đè',
  'docs.rt.locked': '{name} đang chỉnh sửa trang này.',
  'docs.rt.bold': 'Đậm',
  'docs.rt.italic': 'Nghiêng',
  'docs.rt.underline': 'Gạch chân',
  'docs.rt.strike': 'Gạch ngang',
  'docs.rt.inlineCode': 'Mã nội dòng',
  'docs.rt.subscript': 'Chỉ số dưới',
  'docs.rt.superscript': 'Chỉ số trên',
  'docs.rt.moreFormatting': 'Định dạng khác',
  'docs.rt.link': 'Liên kết',
  'docs.link.searchPlaceholder': 'Tìm liên kết gần đây hoặc dán URL',
  'docs.link.displayPlaceholder': 'Văn bản hiển thị (tuỳ chọn)',
  'docs.link.tab.all': 'Tất cả',
  'docs.link.tab.docs': 'Tài liệu',
  'docs.link.tab.issues': 'Issue',
  'docs.link.recents': 'Gần đây',
  'docs.link.noResults': 'Không có trang hoặc issue phù hợp.',
  'docs.link.willLink': 'Sẽ liên kết tới',
  'docs.link.cancel': 'Huỷ',
  'docs.link.remove': 'Xoá liên kết',
  'docs.link.insert': 'Chèn',
  'docs.rt.blockType': 'Kiểu văn bản',
  'docs.rt.normalText': 'Văn bản thường',
  'docs.rt.textColor': 'Màu chữ',
  'docs.rt.highlight': 'Tô nền',
  'docs.rt.colorRemove': 'Xoá',
  'docs.rt.lists': 'Danh sách',
  'docs.rt.align': 'Căn lề',
  'docs.rt.align.left': 'Căn trái',
  'docs.rt.align.center': 'Căn giữa',
  'docs.rt.align.right': 'Căn phải',
  'docs.rt.align.justify': 'Căn đều',
  'docs.rt.emoji': 'Biểu tượng cảm xúc',
  'docs.rt.insert': 'Chèn',
  'docs.block.handle': 'Tuỳ chọn khối',
  'docs.block.moveUp': 'Chuyển lên',
  'docs.block.moveDown': 'Chuyển xuống',
  'docs.block.duplicate': 'Nhân bản',
  'docs.block.delete': 'Xoá',
  'docs.block.turnInto': 'Chuyển thành',
  'docs.rt.undo': 'Hoàn tác',
  'docs.rt.redo': 'Làm lại',
  'docs.rt.clearFormat': 'Xoá định dạng',
  'docs.rt.indent': 'Thụt vào',
  'docs.rt.outdent': 'Thụt ra',
  'docs.rt.h1': 'Tiêu đề 1',
  'docs.rt.h2': 'Tiêu đề 2',
  'docs.rt.h3': 'Tiêu đề 3',
  'docs.rt.h4': 'Tiêu đề 4',
  'docs.rt.h5': 'Tiêu đề 5',
  'docs.rt.h6': 'Tiêu đề 6',
  'docs.rt.bulletList': 'Danh sách gạch đầu dòng',
  'docs.rt.bullet.disc': 'Chấm tròn đặc',
  'docs.rt.bullet.circle': 'Chấm tròn rỗng',
  'docs.rt.bullet.square': 'Ô vuông',
  'docs.rt.bullet.dash': 'Gạch ngang',
  'docs.rt.orderedList': 'Danh sách đánh số',
  'docs.rt.task': 'Danh sách công việc',
  'docs.rt.table': 'Bảng',
  'docs.table.insertColumn': 'Chèn cột',
  'docs.rt.code': 'Khối mã',
  'docs.rt.codePlain': 'Văn bản thường',
  'docs.code.format': 'Định dạng',
  'docs.code.formatting': 'Đang định dạng…',
  'docs.code.formatUnsupported': 'Ngôn ngữ này chưa hỗ trợ định dạng',
  'docs.code.formatError': 'Không định dạng được: {message}',
  'docs.code.detectFailed': 'Không nhận diện được ngôn ngữ — chọn ngôn ngữ trong danh sách rồi bấm Định dạng',
  'docs.rt.quote': 'Trích dẫn',
  'docs.rt.panel': 'Bảng thông báo',
  'docs.rt.expand': 'Mở rộng',
  'docs.rt.status': 'Trạng thái',
  'docs.rt.statusText': 'Nhãn (vd ĐANG LÀM)',
  'docs.rt.date': 'Ngày',
  'docs.rt.toc': 'Mục lục',
  'docs.toc.empty': 'Chưa có tiêu đề — thêm tiêu đề H1–H3 sẽ hiện ở đây.',
  'docs.rt.divider': 'Đường phân cách',
  'docs.rt.image': 'Hình ảnh (liên kết)',
  'docs.rt.youtube': 'YouTube',
  'docs.rt.mention': 'Nhắc tên',
  'docs.rt.wikiLink': 'Liên kết trang',
  'docs.rt.issueLink': 'Liên kết issue',
  'docs.rt.include': 'Nhúng trang',
  'docs.rt.excerpt': 'Trích đoạn (có thể nhúng)',
  'docs.rt.table.colAfter': 'Thêm cột bên phải',
  'docs.rt.table.delCol': 'Xoá cột',
  'docs.rt.table.rowBefore': 'Thêm hàng bên trên',
  'docs.rt.table.rowAfter': 'Thêm hàng bên dưới',
  'docs.rt.table.delRow': 'Xoá hàng',
  'docs.rt.table.header': 'Hàng tiêu đề',
  'docs.rt.table.merge': 'Gộp ô',
  'docs.rt.table.split': 'Tách ô',
  'docs.rt.table.delete': 'Xoá bảng',
  // Menu ngữ cảnh cho từng ô (kiểu Confluence)
  'docs.table.cellMenu': 'Tuỳ chọn ô',
  'docs.table.bgColor': 'Màu nền',
  'docs.table.bgNone': 'Không nền',
  'docs.table.align': 'Căn chỉnh',
  'docs.table.clearCell': 'Xoá nội dung ô',
  // Handle chọn hàng/cột + nút "+" ở mép (task 2a)
  'docs.table.selectColumn': 'Chọn cột',
  'docs.table.selectRow': 'Chọn hàng',
  'docs.table.columnMenu': 'Tùy chọn cột',
  'docs.table.rowMenu': 'Tùy chọn hàng',
  'docs.table.sortAsc': 'Sắp xếp tăng dần',
  'docs.table.sortDesc': 'Sắp xếp giảm dần',
  'docs.table.moveColRight': 'Chuyển cột sang phải',
  'docs.table.mergedDisabled': 'Không dùng được với bảng có ô gộp',
  'docs.table.mergeDisabled': 'Chọn từ 2 ô trở lên để gộp',
  'docs.table.splitDisabled': 'Chỉ tách được ô đã gộp',
  // Thanh công cụ bảng nổi (task 2b)
  'docs.table.headerColumn': 'Cột tiêu đề',
  'docs.table.fixedWidths': 'Cố định độ rộng cột',
  'docs.table.numberedRows': 'Đánh số hàng',
  'docs.table.resizeTable': 'Đổi cỡ bảng  ⌘⌥⇧R',
  'docs.table.adjustColumn': 'Điều chỉnh cột  ⌘⌥⇧C',
  'docs.table.alignTable': 'Bảng',
  'docs.table.alignCell': 'Ô',
  'docs.table.distribute': 'Chia đều cột',
  // Sơ đồ (Phase 3)
  'docs.rt.edit': 'Sửa',
  'docs.rt.mermaid': 'Sơ đồ Mermaid',
  'docs.rt.noUpload': 'Chỉ dùng liên kết — ứng dụng không lưu tệp. Hãy dán liên kết ảnh https.',
  'docs.rt.richNotEditable': 'Nội dung này có định dạng nâng cao (bảng, khối mã, hình ảnh…) mà trình soạn thảo rút gọn không sửa được, nên chỉ xem ở đây. Nội dung vẫn được giữ nguyên — chỉ là không chỉnh sửa được từ trình soạn thảo này.',
  'docs.rt.mermaidEdit': 'Mã nguồn sơ đồ Mermaid:',
  'docs.rt.mermaidError': 'Không thể hiển thị sơ đồ Mermaid này.',
  'docs.rt.mermaidEmpty': 'Sơ đồ Mermaid trống — bấm Sửa để thêm mã nguồn.',
  'docs.rt.drawio': 'Sơ đồ Draw.io',
  'docs.rt.drawioClose': 'Đóng',
  'docs.rt.drawioCreate': 'Tạo sơ đồ',
  'docs.rt.drawioEmpty': 'Sơ đồ Draw.io trống.',
  'docs.rt.comment': 'Bình luận',
  'docs.rt.commentPrompt': 'Thêm bình luận nội dòng cho phần văn bản đã chọn:',

  // Bình luận tài liệu + theo dõi (Phase 6)
  'docs.comments.footer': 'Bình luận trang',
  'docs.comments.inline': 'Bình luận nội dòng',
  'docs.comments.empty': 'Chưa có bình luận nào.',
  'docs.comments.inlineEmpty': 'Chưa có bình luận nội dòng. Bôi đen văn bản trong trang rồi chọn “Bình luận” để thêm.',
  'docs.comments.add': 'Bình luận',
  'docs.comments.reply': 'Trả lời',
  'docs.comments.replyingTo': 'Đang trả lời',
  'docs.comments.replyPlaceholder': 'Viết trả lời…',
  'docs.comments.placeholder': 'Thêm bình luận… dùng @ để nhắc ai đó.',
  'docs.comments.edit': 'Sửa',
  'docs.comments.delete': 'Xoá',
  'docs.comments.deleteConfirm': 'Xoá bình luận này? Các trả lời cũng bị xoá theo.',
  'docs.comments.edited': 'đã sửa',
  'docs.comments.resolve': 'Đánh dấu xử lý',
  'docs.comments.reopen': 'Mở lại',
  'docs.comments.resolved': 'Đã xử lý',
  'docs.comments.resolvedBy': 'Xử lý bởi {who}',
  'docs.comments.showResolved': 'Hiện đã xử lý ({n})',
  'docs.comments.hideResolved': 'Ẩn đã xử lý',
  'docs.comments.anchor': 'Tại: “{text}”',
  'docs.comments.orphan': 'đã bỏ đánh dấu',
  'docs.comments.save': 'Lưu',
  'docs.comments.cancel': 'Huỷ',
  'docs.comments.error': 'Không thể lưu bình luận.',
  'docs.comments.selectionAdd': 'Bình luận',
  'docs.comments.selectionPlaceholder': 'Bình luận về đoạn đã chọn… dùng @ để nhắc ai đó.',
  'docs.watch.follow': 'Theo dõi',
  'docs.watch.following': 'Đang theo dõi',
  'docs.watch.followHint': 'Nhận thông báo khi có bình luận và chỉnh sửa mới trên trang này.',

  // Nhãn + tìm kiếm toàn văn (Phase 7)
  'docs.labelsField': 'Nhãn',
  'docs.search.advanced': 'Tìm kiếm nâng cao →',
  'docs.search.backToTree': '← Về danh sách trang',
  'docs.search.heading': 'Tìm kiếm tài liệu',
  'docs.search.labelHeading': 'Trang gắn nhãn “{label}”',
  'docs.search.count': '{n} kết quả',
  'docs.search.prompt': 'Nhập từ khoá, hoặc chọn bộ lọc, để tìm trong các tài liệu bạn được xem.',
  'docs.search.scope': 'Phạm vi',
  'docs.search.anyScope': 'Mọi nơi',
  'docs.search.label': 'Nhãn',
  'docs.search.anyLabel': 'Mọi nhãn',
  'docs.search.owner': 'Chủ sở hữu (mã NV)',
  'docs.search.from': 'Cập nhật từ',
  'docs.search.to': 'Cập nhật đến',
  'docs.search.clear': 'Xoá bộ lọc',
  'docs.search.more': 'Tải thêm',

  // Bản nháp & tự động lưu (Phase 8)
  'docs.draft.saving': 'Đang lưu nháp…',
  'docs.draft.saved': 'Đã lưu nháp',
  'docs.draft.unsaved': 'Có thay đổi chưa lưu',
  'docs.draft.badge': 'Bản nháp chưa đăng',
  'docs.draft.resumedHint': 'Đang sửa bản nháp chưa đăng của bạn từ {at}.',
  'docs.draft.discard': 'Bỏ',
  'docs.draft.discardResumed': 'Bỏ nháp',
  'docs.draft.mineTitle': 'Bản nháp của bạn',
  'docs.draft.mineEmpty': 'Chưa có bản nháp. Các chỉnh sửa được tự động lưu ở đây cho đến khi bạn đăng.',
  'docs.draft.untitled': 'Chưa có tiêu đề',
  'docs.draft.newPage': 'Trang mới',
  'docs.draft.behind': 'Trang đã thay đổi',

  // Mẫu & blueprint (Phase 9)
  'docs.tpl.pickTitle': 'Bắt đầu từ một mẫu, hoặc trang trắng:',
  'docs.tpl.blank': 'Trang trắng',
  'docs.tpl.blankHint': 'Bắt đầu với tài liệu trống.',
  'docs.tpl.adminTitle': 'Mẫu trang',
  'docs.tpl.new': 'Mẫu mới',
  'docs.tpl.name': 'Tên',
  'docs.tpl.projectKey': 'Mã project (tuỳ chọn)',
  'docs.tpl.projectKeyHint': 'Trống = dùng chung (mọi người)',
  'docs.tpl.description': 'Mô tả',
  'docs.tpl.body': 'Nội dung (Markdown)',
  'docs.tpl.bodyHint': 'Markdown — được chuyển đổi và làm sạch khi lưu, như mọi trang.',
  'docs.tpl.replaceBody': 'Thay nội dung',
  'docs.tpl.adminEmpty': 'Chưa có mẫu nào.',
  'docs.tpl.edit': 'Sửa',
  'docs.tpl.delete': 'Xoá',
  'docs.tpl.deleteConfirm': 'Xoá mẫu này?',

  // Liên kết, backlink & nhúng (Phase 10)
  'docs.links.title': 'Trang liên kết đến đây',
  'docs.links.linksHere': 'liên kết đến',
  'docs.links.includedBy': 'nhúng trang này',
  'docs.links.issues': 'Issue liên quan',
  'docs.include.from': 'Nhúng từ {title}',
  'docs.include.open': 'Mở trang nguồn',
  'docs.include.forbidden': 'Bạn không có quyền xem nội dung được nhúng.',
  'docs.include.missing': 'Trang được nhúng đã bị xoá.',
  'docs.include.cycle': 'Nhúng vòng lặp — không hiển thị.',
  'docs.include.depth': 'Nhúng lồng quá sâu — không hiển thị.',
  'docs.include.unresolved': 'Nội dung được nhúng.',

  // Macro thuộc tính trang / dữ liệu động (Phase 10)
  'docs.rt.properties': 'Thuộc tính trang',
  'docs.rt.children': 'Trang con',
  'docs.rt.propertiesReport': 'Báo cáo thuộc tính',
  'docs.props.key': 'Thuộc tính',
  'docs.props.value': 'Giá trị',
  'docs.props.page': 'Trang',
  'docs.props.empty': 'Chưa có thuộc tính.',
  'docs.macro.children': 'Trang con',
  'docs.macro.childrenNew': 'Lưu trang để hiển thị các trang con.',
  'docs.macro.childrenEmpty': 'Không có trang con.',
  'docs.macro.report': 'Báo cáo thuộc tính',
  'docs.macro.reportEmpty': 'Không có trang nào có thuộc tính trong phạm vi.',

  // Trang chủ, yêu thích, xuất (Phase 11)
  'docs.home.favourites': 'Yêu thích',
  'docs.home.recentlyViewed': 'Xem gần đây',
  'docs.home.recentlyUpdated': 'Cập nhật gần đây',
  'docs.home.noFavourites': 'Chưa có trang yêu thích. Gắn sao để ghim vào đây.',
  'docs.home.noViews': 'Chưa xem trang nào.',
  'docs.favourite': 'Yêu thích',
  'docs.unfavourite': 'Bỏ yêu thích',
  'docs.export.print': 'In / PDF',

  // Báo cáo issue cho admin/CTO
  'issues.report.title': 'Báo cáo Issue',
  'issues.report.meta': '{n} issue · cập nhật {at}',
  'issues.report.forbidden': 'Chỉ dành cho Admin và CTO.',
  'issues.report.error': 'Không tải được báo cáo.',
  'issues.report.none': '(không có)',
  'issues.report.filters': 'Bộ lọc',
  'issues.report.clear': 'Xóa bộ lọc',
  'issues.report.search': 'Tìm…',
  'issues.report.noValues': 'Không có giá trị',
  'issues.report.selectAll': 'Chọn tất cả (đang hiện)',
  'issues.report.deselect': 'Bỏ chọn',
  'issues.report.noData': 'Không có dữ liệu',
  'issues.report.other': 'Khác',
  'issues.report.clickFilter': 'Bấm để lọc',
  'issues.report.days': 'ngày',
  'issues.report.done': 'Đã xong',
  'issues.report.open': 'Đang mở',
  'issues.report.dim.project': 'Project',
  'issues.report.dim.type': 'Loại',
  'issues.report.dim.reporter': 'Reporter',
  'issues.report.dim.devFix': 'Dev fix',
  'issues.report.dim.status': 'Trạng thái',
  'issues.report.dim.priority': 'Ưu tiên',
  'issues.report.date.all': 'Toàn bộ thời gian',
  'issues.report.date.d7': '7 ngày qua',
  'issues.report.date.d30': '30 ngày qua',
  'issues.report.date.d90': '90 ngày qua',
  'issues.report.date.mtd': 'Tháng này',
  'issues.report.date.ytd': 'Năm nay',
  'issues.report.date.from': 'Từ',
  'issues.report.date.to': 'đến',
  'issues.report.date.apply': 'Áp dụng',
  'issues.report.kpi.total': 'Tổng issue',
  'issues.report.kpi.total.sub': '{n} tạo trong 7 ngày qua',
  'issues.report.kpi.open': 'Đang mở',
  'issues.report.kpi.open.sub': '{n} issue mở ở mức ưu tiên cao',
  'issues.report.kpi.done': 'Đã xong',
  'issues.report.kpi.done.sub': '{p}% tổng số',
  'issues.report.kpi.avg': 'Thời gian xử lý TB',
  'issues.report.kpi.avg.sub': 'Trung vị {m} ngày · {n} issue',
  'issues.report.kpi.avg.none': 'Chưa có issue nào đã xong',
  'issues.report.trend.title': 'Xu hướng theo tuần',
  'issues.report.trend.sub': 'Số issue tạo mới và đã giải quyết mỗi tuần (tuần bắt đầu thứ Hai)',
  'issues.report.trend.created': 'Tạo mới',
  'issues.report.trend.resolved': 'Đã giải quyết',
  'issues.report.byStatus': 'Theo trạng thái',
  'issues.report.byStatus.sub': 'Số issue ở mỗi trạng thái',
  'issues.report.byPriority': 'Theo mức ưu tiên',
  'issues.report.byPriority.sub': 'Tổng issue theo ưu tiên',
  'issues.report.byReporter': 'Top Reporter',
  'issues.report.byReporter.sub': 'Người báo nhiều nhất (top 10)',
  'issues.report.byDev': 'Top Dev fix',
  'issues.report.byDev.sub': 'Issue gán cho mỗi dev (top 10)',
  'issues.report.pivot.title': 'Bảng tổng hợp',
  'issues.report.pivot.sub': 'Theo từng nhóm: tổng, đang mở, đã xong, tỷ lệ xong, thời gian xử lý TB',
  'issues.report.pivot.total': 'Tổng cộng',
  'issues.report.col.total': 'Tổng',
  'issues.report.col.open': 'Đang mở',
  'issues.report.col.done': 'Đã xong',
  'issues.report.col.rate': 'Tỷ lệ xong',
  'issues.report.col.hiOpen': 'Mở ưu tiên cao',
  'issues.report.col.avgDays': 'TB ngày xử lý',
  'issues.report.col.key': 'Mã',
  'issues.report.col.summary': 'Tiêu đề',
  'issues.report.col.project': 'Project',
  'issues.report.col.type': 'Loại',
  'issues.report.col.priority': 'Ưu tiên',
  'issues.report.col.status': 'Trạng thái',
  'issues.report.col.reporter': 'Reporter',
  'issues.report.col.devFix': 'Dev fix',
  'issues.report.col.created': 'Ngày tạo',
  'issues.report.col.resolved': 'Ngày xong',
  'issues.report.col.fixDays': 'Số ngày',
  'issues.report.list.title': 'Danh sách issue',
  'issues.report.list.search': 'Tìm theo mã, tiêu đề, người…',
  'issues.report.list.count': '{n} issue · bấm tiêu đề cột để sắp xếp',
  'issues.report.list.empty': 'Không có issue nào khớp',
  'issues.report.csv': 'Xuất CSV',
  'issues.report.print': 'In / PDF',
  'issues.report.page': 'Trang {a}/{b}',
}
